// Average video consumption for one day: how long an average television spent
// on the channel, in minutes.
//
// The formula is the panel's own, kept here so the Avg. Vid. Con. chart and the
// Management Report cannot drift apart — they are the same number and a reader
// comparing the two would be right to expect them to match.
//
//   sumMinutes = Σ floor(minute / 2)      active-TV-minutes across the day
//   dailyAvg   = floor(sumMinutes / 1440) average active TV across the day
//   avc        = dailyAvg * 1440 / unique minutes per unique television

export function avgVideoConsumptionForDay(minutes, uniqueTv) {
  if (!Array.isArray(minutes) || minutes.length !== 1440) return null;

  // Without a unique count there is nothing to divide by. Returning zero would
  // read as "nobody watched" rather than "we cannot say".
  const unique = Number(uniqueTv) || 0;
  if (unique <= 0) return null;

  let sumMinutes = 0;
  for (let i = 0; i < 1440; i++) {
    sumMinutes += Math.floor((Number(minutes[i]) || 0) / 2);
  }

  const dailyAvg = Math.floor(sumMinutes / 1440);
  return Number(((dailyAvg * 1440) / unique).toFixed(2));
}
